import sanityClient from '@sanity/client';
import imageURLBuilder from '@sanity/image-url';

export const client = sanityClient({
    projectId: 'ph2d8vr9',
    dataset: 'production',
    apiVersion: '2022-02-01',
    useCdn: true,
    token: 'skDtyyp3hePLvH00zKaPSCYeo7fY6ME88EE4CgDyrdW8jFrwlQiUf5KpgFKfKonGAXx6kbOqIqTGzceiU9GHKEYB6mx4m0ZQriU4gdQMMcPQic3MGx1CaXpBROiuPvU4tVg3CzQnVMELVeUjtIb1VmFCa9nU0g4EOFXCbzgNxFdMwxSp4Qnb',
});

const builder = imageURLBuilder(client);

export const urlFor = (source) => builder.image(source);